import React, { useState } from 'react';
import { ContainerFormForStatusFooter, ContainerMenu } from '../../../../components/Containers';
import HeaderTitle from '../../../../components/HeaderTitle';
import ButtonOptionSystem from '../../../../components/NovoSistema/ButtonOptionSystem';
import { SelectSystemHeader } from '../../../../components/NovoSistema/SelectSystemHeader';
import CadastroDeUsuario from '../../CadastroDeUsuario';
import CadEmpresaN1 from './CadEmpresaN1';
import CadDivisaoN2 from './CadDivisaoN2';
import CadDeAreaN3 from './CadDeAreaN3';
import CadDeDeptoN4 from './CadDeDeptoN4';
import CadastroDeCliente from './CadastroDeCliente';
import PlanoDeContas from './PlanoDeContas';
import CadastroDeAlcadas from '../GestaoAlcadas/CadastroDeAlcadas';
import DiasUteis from './DiasUteis';
import ProdutoServicoN5 from './ProdutoServicoN5';
import CadastroDeCDR from './CadastroDeCDR';
import ComposicaoDoCusto from './ComposicaoDoCusto';
import CompisicaoDoPreco from './CompisicaoDoPreco';
import CAPEX from './CAPEX';

export default function TemplateEstruturaOrcamentaria() {
  const [systemOption, setSystemOption] = useState('');
  return (
    <ContainerMenu>
      <ContainerFormForStatusFooter>
        <HeaderTitle text="Estrutura Orçamentária" linkIcon="/images/icons/keys.svg" />
        <SelectSystemHeader>
          <ButtonOptionSystem
            systemName="Cad. Empresa - N1"
            color=""
            border="#70309F"
            active={systemOption === 'Cad. Empresa - N1' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Cad. Divisão - N2"
            color=""
            border="#70309F"
            active={systemOption === 'Cad. Divisão - N2' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Cad. de Área - N3"
            color=""
            border="#70309F"
            active={systemOption === 'Cad. de Área - N3' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Cad. de Depto. - N4"
            color=""
            border="#70309F"
            active={systemOption === 'Cad. de Depto. - N4' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Produto/Serviço - N5"
            color=""
            border="#70309F"
            active={systemOption === 'Produto/Serviço - N5' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Cadastro de CDR"
            color=""
            border="#70309F"
            active={systemOption === 'Cadastro de CDR' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Cadastro de Cliente"
            color=""
            border="#70309F"
            active={systemOption === 'Cadastro de Cliente' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Cadastro Fornecedor"
            color=""
            border="#70309F"
            active={systemOption === 'Cadastro Fornecedor' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Cadastro de Usuário"
            color=""
            border="#70309F"
            active={systemOption === 'Cadastro de Usuário' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Plano de Contas"
            color=""
            border="#70309F"
            active={systemOption === 'Plano de Contas' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Dias Úteis"
            color=""
            border="#70309F"
            active={systemOption === 'Dias Úteis' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="CAPEX"
            color=""
            border="#70309F"
            active={systemOption === 'CAPEX' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Composição Caixa"
            color=""
            border="#70309F"
            active={systemOption === 'Composição Caixa' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Composição do Custo"
            color=""
            border="#70309F"
            active={systemOption === 'Composição do Custo' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Composição do Preço"
            color=""
            border="#70309F"
            active={systemOption === 'Composição do Preço' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Composição Receita"
            color=""
            border="#70309F"
            active={systemOption === 'Composição Receita' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Composição Despesa"
            color=""
            border="#70309F"
            active={systemOption === 'Composição Despesa' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Cadastro de Alçadas"
            color=""
            border="#70309F"
            active={systemOption === 'Cadastro de Alçadas' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
        </SelectSystemHeader>
        {systemOption === 'Cad. Empresa - N1' && <CadEmpresaN1 />}
        {systemOption === 'Cad. Divisão - N2' && <CadDivisaoN2 />}
        {systemOption === 'Cad. de Área - N3' && <CadDeAreaN3 />}
        {systemOption === 'Cad. de Depto. - N4' && <CadDeDeptoN4 />}
        {systemOption === 'Produto/Serviço - N5' && <ProdutoServicoN5 />}
        {systemOption === 'Cadastro de CDR' && <CadastroDeCDR />}
        {systemOption === 'Cadastro de Cliente' && <CadastroDeCliente />}
        {systemOption === 'Cadastro Fornecedor' && <CadastroDeCliente />}
        {systemOption === 'Cadastro de Usuário' && <CadastroDeUsuario />}
        {systemOption === 'Plano de Contas' && <PlanoDeContas />}
        {systemOption === 'Dias Úteis' && <DiasUteis />}
        {systemOption === 'CAPEX' && <CAPEX />}

        {systemOption === 'Composição do Custo' && <ComposicaoDoCusto />}
        {systemOption === 'Composição do Preço' && <CompisicaoDoPreco />}

        {systemOption === 'Cadastro de Alçadas' && <CadastroDeAlcadas />}
      </ContainerFormForStatusFooter>
    </ContainerMenu>
  );
}
